import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {


    selected_region = 'all';
    regions = [];
    attractions = [];
    events = [];
    blogs = [];
    essential_categories = [];
    selected_essential = 0;
    tours = [];


    constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

    }

    ngOnInit() {

        this.getRegions();
        this.getAttractions();
        this.getBeInspired();
        this.getWhatsOn();
        this.getEssentialCategories();
        this.getTours();
    }

    getAttractions(region = 'all') {
        this.selected_region = region;
        var url = Conf.API_URL + '/get-attractions/';
        if (region != 'all') {
            url += '?region=' + region
        }

        this.http.get(url).subscribe(
            data => {
                this.attractions = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getRegions() {
        this.http.get(Conf.API_URL + '/regions/?show_all').subscribe(
            data => {
                this.regions = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );

    }

    getBeInspired() {
        this.http.get(Conf.API_URL + '/get-blogs/').subscribe(
            data => {
                this.blogs = data['results']
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getWhatsOn() {
        this.http.get(Conf.API_URL + '/get-events/').subscribe(
            data => {
                this.events = data['results']
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getTours() {
        this.http.get(Conf.API_URL + '/get-tours/').subscribe(
            data => {
                this.tours = data['results']
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getEssentialCategories() {

        this.http.get(Conf.API_URL + '/category-for-essential/?show_all&is_active=1').subscribe(
            data => {
                this.essential_categories = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    firstParagraph(html) {
        return FunctionsService.firstParagraph(html)
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/home/home.component.ts